const inputNumeric = () => {
 const SELECTOR_NUMERIC = `[type='number'], [inputmode='numeric']`;

 const beforeValues = new WeakMap();

 const handleBeforeInput = ({ target }) => {
 if (!target.matches(SELECTOR_NUMERIC)) return;

 beforeValues.set(target, target.value);
 };

 const handleInput = ({ target }) => {
 if (!target.matches(SELECTOR_NUMERIC)) return;

 const value = parseFloat(target.value);
 const min = parseFloat(target.min || target.dataset.min);
 const max = parseFloat(target.max || target.dataset.max);

 const isValidPattern = !target.validity.patternMismatch;
 const isInRange =
 target.value === `` ||
 ((isNaN(min) || value >= min) && (isNaN(max) || value <= max));

 if (!isValidPattern || !isInRange) {
 target.value = beforeValues.get(target) || ``;
 } else {
 beforeValues.set(target, target.value);
 }
 };

 const initialize = () => {
 document.body.addEventListener(`beforeinput`, handleBeforeInput);
 document.body.addEventListener(`input`, handleInput);
 };

 initialize();

 inputNumeric.cleanup = () => {
 document.body.removeEventListener(`beforeinput`, handleBeforeInput);
 document.body.removeEventListener(`input`, handleInput);
 };
};

export default inputNumeric;
